.dot {
  display: block;
  box-sizing: border-box;
  width: var(--card-image-action-dot-size, 16px);
  height: var(--card-image-action-dot-size, 16px);
  border: 2px solid var(--colors-grays-mid);
  border-radius: 50%;
}

.indicator_selected .dot {
  border-color: var(--colors-primary-dark);
  background: var(--colors-primary-main);
}

.indicator:enabled:hover .dot,
.indicator:enabled:focus-visible .dot {
  border-color: var(--colors-grays-dark);
}

.indicator_selected:enabled:hover .dot,
.indicator_selected:enabled:focus-visible .dot {
  border-color: var(--colors-primary-dark);
  background: var(--colors-primary-dark);
}
